import { Term } from 'services/terms-and-conditions/types'
import { getTermsDigitalAccount, getTermsRemittanceAccount } from 'services/terms-and-conditions'

import { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

export const useGetTermsDigitalAccount = (
  institution?: string,
  options?: Omit<UseQueryOptions<Term[]>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<Term[]>({
    queryKey: ['terms-digital-account', 'digital-account', institution],
    queryFn: () => getTermsDigitalAccount(institution),
    ...options,
  })

export const useGetTermsRemittanceAccount = (
  options?: Omit<UseQueryOptions<Term[]>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<Term[]>({
    queryKey: ['terms-remittance', 'remittance'],
    queryFn: () => getTermsRemittanceAccount(),
    ...options,
  })
